import { Component } from "react";
import * as React from "react";
import { Redirect } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import SimpleSingleRateStatement from "src/components/projects/project/statements/simple/singlerate/SimpleSingleRateStatement";
import StatementNavbar from "src/components/projects/project/statements/StatementNavbar";
import { IPdfPage } from "src/global";
import { IDefaultProps } from "src/interfaces";
import fs from "src/services/config/fbConfig";
import { ISimpleSingleRateStatementPageState } from "./interfaces";

export default class SimpleSingleRateStatementPage extends Component<
  IDefaultProps,
  ISimpleSingleRateStatementPageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  private statementDocument: firebase.firestore.DocumentReference;
  private simpleStatementDocument: firebase.firestore.DocumentReference;
  public constructor(props: IDefaultProps) {
    super(props);

    this.state = {
      loading: true,
      needsSaving: false,
      statementDate: Date.now(),
      yearsWithSolar: 0,
      totalAmountDue: 0,
      gridUsage: 0,
      solarUsage: 0,
      solarGenerated: 0,
      lastMonthCredit: 0,
      serviceStartDate: Date.now(),
      serviceEndDate: Date.now(),
      allowStatementUpload: false,
      allowStatementParsing: false,
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
      priorDataEditable: false,
    };

    this.renderStatementNavbar = this.renderStatementNavbar.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSaveAndClose = this.handleSaveAndClose.bind(this);

    this.handleStatementDate = this.handleStatementDate.bind(this);
    this.handleYearsWithSolar = this.handleYearsWithSolar.bind(this);
    this.handleTotalAmountDue = this.handleTotalAmountDue.bind(this);

    this.handleGridUsage = this.handleGridUsage.bind(this);
    this.handleSolarUsage = this.handleSolarUsage.bind(this);
    this.handleSolarGenerated = this.handleSolarGenerated.bind(this);
    this.handleLastMonthCredit = this.handleLastMonthCredit.bind(this);

    this.handleServiceStartDate = this.handleServiceStartDate.bind(this);
    this.handleServiceEndDate = this.handleServiceEndDate.bind(this);

    this.handleFilenameChanged = this.handleFilenameChanged.bind(this);
    this.deleteUploadedStatement = this.deleteUploadedStatement.bind(this);
    this.setStoragePath = this.setStoragePath.bind(this);
    this.saveData = this.saveData.bind(this);
    this.setUploadStatus = this.setUploadStatus.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
    this.statementDocument = this.projectDocument
      .collection("statements")
      .doc(this.props.match.params.id);
    this.simpleStatementDocument = this.projectDocument
      .collection("simpleSingleRateStatements")
      .doc(this.statementDocument.id);
  }

  public componentDidMount() {
    this.projectDocument
      .get()
      .then(doc => {
        if (doc.exists) {
          const { allowStatementUpload, allowStatementParsing } = doc.data() as any;
          this.setState({
            allowStatementUpload: allowStatementUpload ? allowStatementUpload : false,
            allowStatementParsing: allowStatementParsing ? allowStatementParsing : false,
            priorDataEditable: false,
          });
        }
      })
      .then(() => {
        this.statementDocument
          .get()
          .then(doc => {
            if (doc.exists) {
              const {
                statementDate,
                yearsWithSolar,
                totalAmountDue,
                serviceStartDate,
                serviceEndDate,
                storagePath,
                filename,
                uploaded,
              } = doc.data() as any;
              this.setState({
                statementDate: statementDate ? statementDate : Date.now(),
                yearsWithSolar: yearsWithSolar ? yearsWithSolar : 0,
                totalAmountDue: totalAmountDue ? totalAmountDue : 0,
                serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
                serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
                storagePath: storagePath ? storagePath : "",
                filename: filename ? filename : "",
                uploaded: uploaded ? uploaded : false,
              });

              if (storagePath && storagePath !== "") {
                const storedFile = fs.fsStorage.ref().child(storagePath);
                storedFile
                  .getMetadata()
                  .then(metaData => {
                    const filename = metaData.customMetadata.filename;
                    this.setState({ filename, uploaded: true });
                  })
                  .catch(error => {
                    console.log(error);
                  });
              }
            }
          })
          .then(() => {
            this.simpleStatementDocument.get().then(doc => {
              if (doc.exists) {
                const {
                  gridUsage,
                  solarUsage,
                  solarGenerated,
                  lastMonthCredit,
                } = doc.data() as any;
                this.setState({
                  gridUsage: gridUsage ? gridUsage : 0,
                  solarUsage: solarUsage ? solarUsage : 0,
                  solarGenerated: solarGenerated ? solarGenerated : 0,
                  lastMonthCredit: lastMonthCredit ? lastMonthCredit : 0,
                });
              } else {
                this.simpleStatementDocument.set({
                  gridUsage: 0,
                  solarUsage: 0,
                  solarGenerated: 0,
                  lastMonthCredit: 0,
                });
              }
            });
          })
          .then(() => {
            this.setState({ needsSaving: false, loading: false });
          });
      });
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }
    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    return (
      <div className="container-fixed-navbar">
        {this.renderStatementNavbar()}
        <SimpleSingleRateStatement
          appService={this.props.appService}
          serviceStartDate={this.state.serviceStartDate}
          serviceStartDateChanged={this.handleServiceStartDate}
          serviceEndDate={this.state.serviceEndDate}
          serviceEndDateChanged={this.handleServiceEndDate}
          statementDate={this.state.statementDate}
          yearsWithSolar={this.state.yearsWithSolar}
          totalAmountDue={this.state.totalAmountDue}
          gridUsage={this.state.gridUsage}
          solarUsage={this.state.solarUsage}
          solarGenerated={this.state.solarGenerated}
          handleStatementDate={this.handleStatementDate}
          handleYearsWithSolar={this.handleYearsWithSolar}
          handleTotalAmountDue={this.handleTotalAmountDue}
          handleGridUsage={this.handleGridUsage}
          handleSolarUsage={this.handleSolarUsage}
          handleSolarGenerated={this.handleSolarGenerated}
          lastMonthCredit={this.state.lastMonthCredit}
          handleLastMonthCredit={this.handleLastMonthCredit}
        />
      </div>
    );
  }

  private renderStatementNavbar() {
    const brand = this.props.appService.getActiveProjectLocation();
    return (
      <StatementNavbar
        appService={this.props.appService}
        match={this.props.match}
        history={this.props.history}
        isAdvanced={false}
        allowStatementParsing={this.state.allowStatementParsing}
        allowStatementUpload={this.state.allowStatementUpload}
        brand={brand}
        file={this.state.file}
        filename={this.state.filename}
        handleFilenameChanged={this.handleFilenameChanged}
        importPDFData={this.importPDFData}
        setStoragePath={this.setStoragePath}
        needsSaving={this.state.needsSaving}
        storagePath={this.state.storagePath}
        saveData={this.saveData}
        deleteUploadedStatement={this.deleteUploadedStatement}
        uploaded={this.state.uploaded}
        setUploadStatus={this.setUploadStatus}
        priorDataEditable={this.state.priorDataEditable}
      />
    );
  }

  private handleSave(e: any) {
    e.preventDefault();
    this.saveData(this.state.needsSaving);
  }

  private saveData(needsSaving: boolean) {
    if (needsSaving) {
      this.setState({ loading: true });
      this.simpleStatementDocument
        .update({
          gridUsage: Number(this.state.gridUsage),
          solarUsage: Number(this.state.solarUsage),
          solarGenerated: Number(this.state.solarGenerated),
          lastMonthCredit: Number(this.state.lastMonthCredit),
        })
        .then(() => {
          this.statementDocument
            .update({
              statementDate: Number(this.state.statementDate),
              yearsWithSolar: Number(this.state.yearsWithSolar),
              totalAmountDue: Number(this.state.totalAmountDue),
              serviceStartDate: Number(this.state.serviceStartDate),
              serviceEndDate: Number(this.state.serviceEndDate),
              storagePath: this.state.storagePath,
              filename: this.state.filename,
              uploaded: this.state.uploaded,
            })
            .then(() => {
              this.setState({ loading: false, needsSaving: false });
            });
        });
    }
  }

  private handleSaveAndClose(e: any) {
    e.preventDefault();
    this.saveData(this.state.needsSaving);
    this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
  }

  private handleStatementDate(value: any) {
    if (!value) {
      return;
    }
    const date = new Date(value).valueOf();
    this.setState({ statementDate: date, needsSaving: true });
  }
  private handleServiceStartDate(value: any) {
    if (!value) {
      return;
    }
    const date = new Date(value).valueOf();
    this.setState({ serviceStartDate: date, needsSaving: true });
  }
  private handleServiceEndDate(value: any) {
    if (!value) {
      return;
    }
    const date = new Date(value).valueOf();
    this.setState({ serviceEndDate: date, needsSaving: true });
  }

  private handleYearsWithSolar(value: any) {
    this.setState({
      yearsWithSolar: Number(value),
      needsSaving: true,
    });
  }
  private handleTotalAmountDue(value: any) {
    this.setState({
      totalAmountDue: Number(value),
      needsSaving: true,
    });
  }
  private handleGridUsage(value: any) {
    this.setState({ gridUsage: Number(value), needsSaving: true });
  }
  private handleSolarUsage(value: any) {
    this.setState({ solarUsage: Number(value), needsSaving: true });
  }
  private handleSolarGenerated(value: any) {
    this.setState({
      solarGenerated: Number(value),
      needsSaving: true,
    });
  }
  private handleLastMonthCredit(value: any) {
    this.setState({
      lastMonthCredit: Number(value),
      needsSaving: true,
    });
  }

  private handleFilenameChanged(e: any) {
    const files: FileList = e.target.files;
    if (files) {
      const file: File = files[0];
      if (file) {
        this.setState({ file, filename: file.name });
      }
    }
  }

  private deleteUploadedStatement() {
    this.setState({
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
    });
    this.saveData(true);
  }

  private importPDFData(pdfPages: IPdfPage[], importType: number): void {
    console.log(pdfPages);
  }

  private setStoragePath(storagePath: string, filename: string): void {
    this.setState({ storagePath, filename });
  }
  private setUploadStatus(uploaded: boolean): void {
    this.setState({ uploaded: true, needsSaving: true });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/statements/simple/singlerate/SimpleSingleRateStatementPage.tsx